module.exports = __webpack_public_path__ + "img/kommune-625.fc0c2f99.svg";